import React from 'react';
export function TopBar() {
  return <div className="top-bar" data-id="element-157">
      Acceso inmediato — Workshop completo por solo <em data-id="element-158">$37 USD</em>
    </div>;
}